import { Injectable } from "@angular/core";
import { ID } from "@common/interfaces/id";
import { IID_OL_RIFERIMENTI } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolRiferimentiState, IIDolRiferimentiStore } from "./iidOlRiferimenti.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.RIFERIMENTI)
export class IIDolRiferimentiQuery extends AbstractInterfaceDataQuery<IID_OL_RIFERIMENTI> {
  constructor(protected store: IIDolRiferimentiStore) {
    super(store);
  }
}
